export default "__VITE_ASSET__47890a59__"